const fundersByProtocol = state => protocol => {
	return state.fundersByProtocol[protocol.id]
}

const selectedProtocol = state => state.selectedProtocol

const researchers = state => state.researchers

const externalResearchers = state => state.externalResearchers

const funders = state => state.funders

const researchLines = state => state.researchLines

const financingCommitments = state => state.financingCommitments

const biosecurityQuestionnaire = state => state.biosecurityQuestionnaire

const readonly = state => state.readonly

const rpbiResearchers = state => state.rpbiResearchers

const renewalAttachments = state => state.renewalAttachments

const motherProtocol = state => state.motherProtocol

export default {
	fundersByProtocol,
	selectedProtocol,
	researchers,
	externalResearchers,
	funders,
	researchLines,
	financingCommitments,
	biosecurityQuestionnaire,
	readonly,
	rpbiResearchers,
	renewalAttachments,
	motherProtocol,
}
